module.exports = "<pricing-page></pricing-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/pricing.html
// module id = 1958
// module chunks = 0